import { Component } from "@angular/core";

/**
 * Onglet factures relevés
 *
 * @author Guillaume TRAVOT
 * @date 21/11/2023
 */
@Component({
    host: {'data-test-id': 'factures-releves'},
    templateUrl: './factures-releves.component.html'
})
export class FacturesRelevesComponent {}
